export default __webpack_public_path__ + "static/media/etq-cube.02739191.svg";